/**
 * Если запрос был отменен возвращает true
 * @param errorMessage - сообщение из response
 */
export const isResponseCanceled = (errorMessage: string) => {
    return errorMessage === 'canceled';
};
